(function() {

    /* globals api */

    'use strict';

    var CollectionState = function(name, identifiers, page, totalPages) {

        this.name = name;

        this.identifiers = identifiers;
        this.currentPage = parseInt(page, 10);
        this.totalPages = parseInt(totalPages, 10);

        sessionStorage.setItem('cs-' + this.name, JSON.stringify(this));

        var identifierMap = {};

        for(var i=0; i<this.identifiers.length; i++) {
            identifierMap[this.identifiers[i]] = i;
        }

        this.identifierMap = identifierMap;

    };

    CollectionState.prototype.hasPage = function(page) {
        return this.totalPages >= page && page >= 1;
    };

    CollectionState.prototype.next = function(currentId) {

        var index;

        index = this.identifierMap[currentId];

        return this.identifiers[index + 1];

    };

    CollectionState.prototype.previous = function(currentId) {

        var index;

        index = this.identifierMap[currentId];

        return this.identifiers[index - 1];

    };

    CollectionState.restore = function(name) {

        var data, state;

        data = sessionStorage.getItem('cs-' + name);

        if(!data) {
            return null;
        }

        data = JSON.parse(data);

        state = new CollectionState(name, data.identifiers, data.currentPage, data.totalPages);

        return state;

    };

    var RecordBrowser = function() {

        var element = document.querySelector('[data-browser]');

        if(!element) {
            return;
        }

        this.collectionName = element.dataset.browser;

        if(element.dataset.browserPage) {

            this.refreshCollection(element);
            return;

        }

        this.currentId = element.dataset.browserCurrent;
        this.collection = CollectionState.restore(this.collectionName);

        this.previousButton = document.querySelector('button[data-browser-previous]');
        this.nextButton = document.querySelector('button[data-browser-next]');

        if(!this.collection || this.collection.identifierMap[this.currentId] === undefined) {

            this.previousButton.style.display = 'none';
            this.nextButton.style.display = 'none';

            return;

        }

        // Check if there is a next page

        if(this.collection.currentPage === this.collection.totalPages && this.collection.identifierMap[this.currentId] === this.collection.identifiers.length - 1) {
            this.nextButton.disabled = true;
        } else {
            this.addNextIdFieldToForm(this.collection.identifiers[this.collection.identifierMap[this.currentId] + 1]);
        }

        // Check if there is a previous page

        if(this.collection.currentPage === 1 && this.collection.identifierMap[this.currentId] === 0) {
            this.previousButton.disabled = true;
        }

        this.initButtons();

    };

    RecordBrowser.prototype.refreshCollection = function(element) {

        var filters = document.querySelector('form.filter');

        filters.addEventListener('sbw:filter-updated', function() {

            var element = document.querySelector('[data-browser]');

            if(!element) {

                this.collection = new CollectionState(this.collectionName, [], this.collection.currentPage, this.collection.totalPages);
                return;

            }

            this.collection = new CollectionState(this.collectionName, JSON.parse(element.dataset.browserIds), element.dataset.browserPage, element.dataset.browserTotalPages);

        }.bind(this), false);

        this.collection = new CollectionState(this.collectionName, JSON.parse(element.dataset.browserIds), element.dataset.browserPage, element.dataset.browserTotalPages);

    };

    RecordBrowser.prototype.initButtons = function() {

        var next, previous;

        next = this.nextButton;
        previous = this.previousButton;

        if(next) {

            next.recordBrowser = this;
            next.addEventListener('click', this.clickHandler, false);

        }

        if(previous) {

            previous.recordBrowser = this;
            previous.addEventListener('click', this.clickHandler, false);

        }

    };

    RecordBrowser.prototype.clickHandler = function(e) {

        e.preventDefault();

        var browser = this.recordBrowser;

        if(this.hasAttribute('data-browser-next')) {
            browser.next();
        } else {
            browser.previous();
        }

    };

    RecordBrowser.prototype.nextId = function(callback, skipUpdate) {

        var targetId = this.collection.next(this.currentId);

        if(targetId !== undefined) {
            callback(targetId);
            return;
        }

        var page = this.getValidPage(this.collection.currentPage + 1);

        if(skipUpdate === true) {

            this.requestData(page, function(data) {
                callback(data.ids[0]);
            });

        } else {

            this.updateCollection(page, function() {

                targetId = this.collection.identifiers[0];
                callback(targetId);

            }.bind(this));

        }

    };

    RecordBrowser.prototype.next = function() {

        this.nextId(function(targetId) {
            window.location.href = this.getBaseUrl() + '/' + targetId + '/edit';
        }.bind(this));

    };

    RecordBrowser.prototype.previousId = function(callback) {

        var targetId = this.collection.previous(this.currentId);

        if(targetId !== undefined) {
            callback(targetId);
            return;
        }

        var page = this.getValidPage(this.collection.currentPage - 1);

        this.updateCollection(page, function() {

            targetId = this.collection.identifiers[this.collection.identifiers.length - 1];
            callback(targetId);

        }.bind(this));

    };

    RecordBrowser.prototype.previous = function() {

        this.previousId(function(previousId) {
            window.location.href = this.getBaseUrl() + '/' + previousId + '/edit';
        }.bind(this));

    };

    RecordBrowser.prototype.getBaseUrl = function() {

        var segments = window.location.pathname.split('/');

        segments = segments.slice(1, segments.length - 2);

        return '/' + segments.join('/');

    };

    RecordBrowser.prototype.getValidPage = function(page) {

        // Check if a valid page was given. If not, start from beginning or return to end.

        if(!this.collection.hasPage(page)) {

            if(page === 0) {
                page = this.collection.totalPages;
            } else {
                page = 1;
            }

        }

        return page;

    };

    RecordBrowser.prototype.requestData = function(page, callback) {

        var url = this.getBaseUrl() + '?page=' + page;

        return api.get(url, { 'Accept': 'application/json' }).then(function(response) {

            response.json().then(callback);

        }.bind(this));

    };


    RecordBrowser.prototype.updateCollection = function(page, callback) {

        this.requestData(page, function(data) {

            this.collection = new CollectionState(this.collectionName, data.ids, data.current_page, data.total_pages);

            if(callback) {
                callback();
            }

        }.bind(this));

    };

    RecordBrowser.prototype.addNextIdFieldToForm = function(id) {

        var form = document.querySelector('.content form'),
            input = document.createElement('input'),
            approveButton = document.getElementById('btn-approve');

        if (!approveButton || !approveButton.dataset.hasOwnProperty('nextRecord')) {
            return;
        }

        if(approveButton) {
            approveButton.disabled = true;
        }

        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'next_id');

        if(id) {

            input.setAttribute('value', id);

            if(approveButton) {
                approveButton.disabled = false;
            }

        } else {

            this.nextId(function (id) {

                if(!id) {
                    form.removeChild(input);
                } else {
                    input.setAttribute('value', id);
                }

                if(approveButton) {
                    approveButton.disabled = false;
                }

            }.bind(this), true);

        }

        form.appendChild(input);

    };

    window.recordBrowser = new RecordBrowser();

})();